import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipPolygon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17_43)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 8C0 6.89543 0.89543 6 2 6H12C13.1046 6 14 6.89543 14 8V18C14 19.1046 13.1046 20 12 20H2C0.89543 20 0 19.1046 0 18V8ZM12 8H2V18H12V8Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 8V12C6 13.1046 6.89543 14 8 14H12V8H6Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 2C6 0.89543 6.89543 0 8 0H8.83333V2H8V2.83333H6V2ZM10.5 0H12.1667V2H10.5V0ZM13.8333 0H15.5V2H13.8333V0ZM17.1667 0H18C19.1046 0 20 0.89543 20 2V2.83333H18V2H17.1667V0ZM6 6V4.5H8V6H7H6ZM20 4.5V6.16667H18V4.5H20ZM20 7.83333V9.5H18V7.83333H20ZM20 11.1667V12C20 13.1046 19.1046 14 18 14H17.1667V12H18V11.1667H20ZM15.5 14H14V12H15.5V14Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17_43",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgClipPolygon;
